import { atom, map } from "nanostores"
import { type AnalysisCompType } from "@/generated/graphql"
import { updateSorting } from "@/stores/compSortingDataStore"

// Atom to keep the currently selected comp
export const $selectedCompDetailId = atom<string | null>(null)

export const setSelectedCompDetailId = (compDetailId: string | null) => {
  $selectedCompDetailId.set(compDetailId)
}

export const compUpdatingState = atom(false)

export const setCompUpdatingState = (isUpdating: boolean) => {
  if (!isUpdating) {
    // Delay setting to false by 200 milliseconds
    setTimeout(() => {
      compUpdatingState.set(false)
    }, 275)
  } else {
    // Set to true immediately
    compUpdatingState.set(true)
  }
}

// UI Selection States

export const compsDataStore = map<{ compsArray: AnalysisCompType[] }>({
  compsArray: [],
})

export const toggleSelectedComp = (compId: string) => {
  const currentState = compsDataStore.get()
  const updatedCompsArray = currentState.compsArray.map((comp) => {
    if (comp.arvcomp?.id === compId) {
      return { ...comp, isSelected: !comp.isSelected }
    }
    return comp
  })
  compsDataStore.set({ compsArray: updatedCompsArray })
}

// Added for adding new comps to the array
export const addComp = (newComp: AnalysisCompType) => {
  // Unnecessary at the moment as the new analysis refreshes in it's entirety
  /* const currentState = compsDataStore.get()
  compsDataStore.set({
    compsArray: [...currentState.compsArray, newComp],
  }) */
  updateSorting("updatedAt", "default")
}

// Scroll to recent comp

export const scrollToRecentStore = atom(false)

export const triggerScrollToRecent = () => {
  scrollToRecentStore.set(true)
}
